<div
  class="app-phonebook !tw-px-[10px]"
  [class]="
    isShowCustomFields ||
    isShowPhonebookHelp ||
    isShowContactAudit ||
    isShowPhonebookAudit
      ? 'd-none'
      : 'row'
  "
>
  <!-- *Phonebooks -->
  <div class="lg:tw-w-1/2 !tw-p-0 tw-overflow-hidden phonebook-max-w">
    <phonebook-list
      class="tw-w-full"
      [isFixedHeight]="false"
      [isShowInputs]="false"
      [justCurrentOrganization]="true"
      [isShowHeader]="true"
      [isShowFullTable]="true"
      [contactsComponent]="contactsComponent()"
      (selectedPhonebookChange)="selectedPhonebook = $event"
      (onShowPhonebookAudit)="isShowPhonebookAudit = $event"
      (onShowPhonebookHelp)="isShowPhonebookHelp = $event"
      (onShowCustomFields)="isShowCustomFields = $event"
      (showAdvanceSearch)="changeAdvanceSearch($event)"
      (callRefresh)="onReloadAdvanceSearch()"
      (justCurrentOrganizationChange)="justCurrentOrganization = $event"
      (customFields)="phonebookCustomFields = $event"
    >
      <div more-content [class.hidden]="!isShowAdvanceSearch">
        <phonebook-advance-search
          [isShowInputs]="false"
          [isFixedHeight]="true"
          [isShowFullTable]="true"
          (phonebookRecipientsChange)="onPhonebookRecipientsChange($event)"
          (selectedPhonebookChange)="setSelectedPhonebookFromAdvancedSearch($event)"
          (onShowCustomFields)="isShowCustomFields = $event"
          [justCurrentOrganization]="justCurrentOrganization"
        ></phonebook-advance-search>
      </div>
    </phonebook-list>
  </div>

  <!-- *Contacts -->
  <div class="lg:tw-w-1/2 p-0">
    <app-contacts
      [selectedPhonebook]="selectedPhonebook"
      (updatePhonebookTable)="getTableData()"
      (isShowContactsForm)="isHidePhonebook = $event"
      (showContactAudit)="isShowContactAudit = $event"
    >
      <!--TODO (contactCount)="updatePhonebookContactCount($event)" -->
    </app-contacts>
  </div>
</div>

<!--* Custom Fields -->
<div class="row" *ngIf="isShowCustomFields">
  <app-phonebook-custom-fields-form
    [phonebookId]="selectedPhonebook?.id"
    (closeFormPage)="
      isShowCustomFields = false; showParent = true; getParentQueryString()
    "
    [customFields]="phonebookCustomFields"
  >
  </app-phonebook-custom-fields-form>
</div>

<!--^ Contacts Audit-->
<app-audit
  *ngIf="isShowContactAudit"
  [service]="contactsService"
  methodName="contactsGetContactsAuditWithPagination"
  (hidePage)="isShowContactAudit = false"
>
</app-audit>

<!--^ Phonebooks Audit-->
<app-audit
  *ngIf="isShowPhonebookAudit"
  [service]="currentService"
  [methodName]="auditApiMethodName"
  (hidePage)="isShowPhonebookAudit = false"
>
</app-audit>

<!--~ Help Page -->
<app-help-page
  *ngIf="isShowPhonebookHelp"
  [menuTitle]="pageName"
  (hidePage)="isShowPhonebookHelp = false"
  [title]="pageConfig.title"
>
</app-help-page>
